import React from "react";
import SkillSection from "./SkillSection";
import type { Theme } from "types";

interface SkillsProps {
  theme: Theme;
}

const Skills: React.FC<SkillsProps> = (props) => {
  const { theme } = props;
  const outcomeSignals = [
    "Architecture ownership",
    "Delivery leadership",
    "Cross-functional execution",
  ];

  return (
    <div className="mt-8 md:mt-10" id="skills">
      <div className="relative overflow-hidden rounded-2xl border border-border/60 bg-[radial-gradient(circle_at_15%_5%,rgba(14,165,233,0.12),transparent_34%),radial-gradient(circle_at_85%_90%,rgba(249,115,22,0.1),transparent_36%)] px-4 py-6 shadow-[0_14px_45px_rgba(0,0,0,0.1)] sm:px-5 md:px-6 md:py-7">
        <div
          className="absolute -top-14 right-0 h-28 w-28 rounded-full bg-sky-300/10 blur-2xl"
          aria-hidden="true"
        />
        <div
          className="absolute -bottom-14 -left-6 h-32 w-32 rounded-full bg-orange-300/10 blur-2xl"
          aria-hidden="true"
        />

        <div className="relative z-10 mb-6 grid gap-4 md:mb-7 md:grid-cols-[1.2fr_0.8fr] md:items-end">
          <div>
            <p className="text-[10px] font-mono tracking-[0.16em] uppercase text-text-muted">
              Core Strengths
            </p>
            <h3 className="mt-2 text-xl font-display font-bold tracking-tight text-text-primary md:text-2xl lg:text-[1.8rem]">
              Technical leadership through systems and delivery.
            </h3>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-text-secondary">
              Built for a senior technical lead profile: clear ownership areas,
              execution depth, and business-facing engineering outcomes.
            </p>
          </div>

          <div className="grid gap-2 sm:grid-cols-3 md:grid-cols-1">
            {outcomeSignals.map((signal) => (
              <div
                key={signal}
                className="rounded-lg border border-border/60 bg-bg-primary/55 px-2.5 py-2 text-[10px] font-mono uppercase tracking-[0.12em] text-text-secondary"
              >
                {signal}
              </div>
            ))}
          </div>
        </div>

        <div className="relative z-10">
          <SkillSection theme={theme} />
        </div>
      </div>
    </div>
  );
};

export default Skills;
